import styled from "styled-components";

export const Button = styled.a`
border-radius : 50px;
background : ${({primary}) => (primary? "#010606": "#01bf71")};
white-space : nowrap;
padding : ${({big}) => (big?'14px 48px':'12px 30px') };
color : ${({dark}) => (dark ? '#fff':'#00000')};
font-size : ${({fontBig}) => (fontBig ? '20px': '16px')};
outline : none;
border : none;
cursor : pointer;
display : flex;
text-decoration : none;
justify-content : center;
align-items : center;
transition : all 0.2 ease-in-out;
&:hover {
    color : ${({dark}) => (dark ? '#010101':'#010606')}; 
    transition : all 0.2s ease-in-out;
    background : ${({primary}) => (primary? "#01BF71":"#010101")};
}
`

